import angular from 'angular'
import axios from 'axios'

function AttendeeJoinController ($scope, $rootScope, vcRecaptchaService) {
  const vm = this

  const ERROR_MESSAGES = {
    name: 'Please enter your name.',
    companyName: 'Please enter your company name.',
    website: 'Please enter your website. URL must start with http:// or https://.',
    email: 'Please enter a valid email address.',
    phoneNumber: 'Please enter a valid phone number.',
    address: 'Please enter your address.',
    city: 'Please enter your city.',
    postalCode: 'Please enter your postal code.'
  }

  vm.RULES = false
  vm.isLoading = false

  vm.widgetId = null
  vm.reCaptcha = null

  vm.SPONSORSHIP_LEVELS = []

  vm.EXPOS = {
    value: null,
    options: []
  }

  vm.COUNTRIES = {
    value: null,
    options: []
  }

  vm.STATES = {
    value: null,
    options: []
  }

  vm.FORM = {
    expoId: '',
    sponsorshipLevel: 0,
    companyName: '',
    name: '',
    email: '',
    phoneNumber: '',
    website: '',
    address: '',
    city: '',
    state: '',
    postalCode: '',
    country: ''
  }

  vm.FORM_ERRORS = {
    name: '',
    companyName: '',
    email: '',
    website: '',
    phoneNumber: '',
    address: '',
    city: '',
    postalCode: ''
  }

  vm.DROPDOWN_ERRORS = {
    expoId: '',
    state: '',
    country: '',
    sponsorshipLevel: ''
  }

  vm.setWidgetId = function (widgetId) {
    vm.widgetId = widgetId
  }

  vm.hasError = function (name) {
    return vm.FORM_ERRORS[name] !== ''
  }

  vm.hasDropdownError = function (name) {
    return vm.DROPDOWN_ERRORS[name] !== ''
  }

  vm.hasAnyErrors = function () {
    let isValid = true
    for (const value of Object.values(vm.FORM_ERRORS)) {
      if (value !== '') {
        isValid = false
        break
      }
    }

    return isValid
  }

  vm.allFieldsFilled = function () {
    let isValid = true
    for (const key of Object.keys(vm.FORM_ERRORS)) {
      if (vm.FORM[key] === '') {
        isValid = false
        break
      }
    }

    return isValid
  }

  vm.changeSponsorshipLevel = function (level) {
    vm.FORM.sponsorshipLevel = level
  }

  vm.changeExpo = function (value) {
    vm.EXPOS.value = value
  }

  vm.changeCountry = function (value) {
    vm.COUNTRIES.value = value
  }

  vm.changeState = function (value) {
    vm.STATES.value = value
  }

  vm.send = () => {
    if (vm.STATES.value === null) {
      vm.DROPDOWN_ERRORS.state = 'Please select a state.'
    } else {
      vm.DROPDOWN_ERRORS.state = ''
    }
    if (vm.COUNTRIES.value === null) {
      vm.DROPDOWN_ERRORS.country = 'Please select a country.'
    } else {
      vm.DROPDOWN_ERRORS.country = ''
    }
    if (vm.EXPOS.value === null) {
      vm.DROPDOWN_ERRORS.expoId = 'Please select an expo.'
    } else {
      vm.DROPDOWN_ERRORS.expoId = ''
    }
    if (vm.FORM.sponsorshipLevel === 0) {
      vm.DROPDOWN_ERRORS.sponsorshipLevel = 'Please select a sponsorship level.'
    } else {
      vm.DROPDOWN_ERRORS.sponsorshipLevel = ''
    }

    let isValid = true
    for (const value of Object.values(vm.DROPDOWN_ERRORS)) {
      if (value !== '') {
        isValid = false
        break
      }
    }
    if (!isValid) {
      return
    }

    if (vcRecaptchaService.getResponse(vm.widgetId) === '') {
      $rootScope.toggleGenericModal('Become an attendee', 'Please check the reCaptcha box.')
      return
    }

    vm.FORM.state = vm.STATES.value.value
    vm.FORM.country = vm.COUNTRIES.value.value
    vm.FORM.expoId = vm.EXPOS.value.value

    const formData = new FormData()
    formData.append('expo_id', vm.FORM.expoId)
    formData.append('sponsorship', vm.FORM.sponsorshipLevel)
    formData.append('companyname', vm.FORM.companyName)
    formData.append('name', vm.FORM.name)
    formData.append('email', vm.FORM.email)
    formData.append('website', vm.FORM.website)
    formData.append('phone', vm.FORM.phoneNumber)
    formData.append('street_address', vm.FORM.address)
    formData.append('city', vm.FORM.city)
    formData.append('state', vm.FORM.state)
    formData.append('country', vm.FORM.country)
    formData.append('zip', vm.FORM.postalCode)

    axios
      .post(process.env.NODE_ENV === 'production' ? `${process.env.APP_URL}/jSON/SponsorForm.php` : `${process.env.LOCAL_APP_URL}/jSON/SponsorForm.php`, formData)
      .then(() => {
        $rootScope.toggleGenericModal('Submission Received', 'Thank you for submitting your interest in Sponsoring! We will be in touch soon.', () => {
          $rootScope.navigateTo('/attendee')
        })
      })
      .catch(e => {
        console.error(e)
        if (e.response && e.response.data && e.response.data.responsemsg) {
          $rootScope.toggleGenericModal('Become an attendee', e.response.data.responsemsg)
        } else {
          $rootScope.toggleGenericModal('Become an attendee', 'We are sorry, but something went wrong. Please try again later.')
        }
      })
      .finally(() => {
        vm.isLoading = false
        $scope.$apply()
      })
  }

  const validateDropdowns = function (type, newValue, oldValue) {
    // Skip initial page load check.
    if (newValue === oldValue) {
      return
    }

    if (type === 'state' || type === 'country' || type === 'expoId') {
      if (newValue === null) {
        vm.DROPDOWN_ERRORS[type] = 'Please select a state.'
      } else {
        vm.DROPDOWN_ERRORS[type] = ''
      }
      if (newValue === null) {
        vm.DROPDOWN_ERRORS[type] = 'Please select a country.'
      } else {
        vm.DROPDOWN_ERRORS[type] = ''
      }
      if (newValue === null) {
        vm.DROPDOWN_ERRORS[type] = 'Please select an expo.'
      } else {
        vm.DROPDOWN_ERRORS[type] = ''
      }
    } else {
      if (newValue === 0) {
        vm.DROPDOWN_ERRORS.sponsorshipLevel = 'Please select a sponsorship level.'
      } else {
        vm.DROPDOWN_ERRORS.sponsorshipLevel = ''
      }
    }
  }

  axios
    .get(process.env.NODE_ENV === 'production' ? `${process.env.APP_URL}/jSON/SponsorFormDisplay.php` : `${process.env.LOCAL_APP_URL}/jSON/SponsorFormDisplay.php`)
    .then(response => {
      if (response.status === 200) {
        const data = response.data

        vm.EXPOS.options = data.expos.map(element => ({
          value: element.id,
          label: element.name
        }))

        vm.SPONSORSHIP_LEVELS = data.sponsorTypes.map(element => ({
          value: element.id,
          label: element.name
        }))
      }
    })
    .catch(e => console.error(e))

  axios
    .get(process.env.NODE_ENV === 'production' ? `${process.env.APP_URL}/jSON/StatesCountries.php` : `${process.env.LOCAL_APP_URL}/jSON/StatesCountries.php`)
    .then(response => {
      if (response.status === 200) {
        const data = response.data

        vm.COUNTRIES.options = data.countries.map(element => ({
          value: element.id,
          label: element.name
        }))

        vm.STATES.options = data.states.map(element => ({
          value: element.id,
          label: element.name
        }))
      }
    })
    .catch(e => console.error(e))

  $scope.$watch(function () {
    return vm.FORM
  }, function (newValue) {
    for (const key of Object.keys(vm.FORM_ERRORS)) {
      if (newValue[key] === undefined) {
        vm.FORM_ERRORS[key] = ERROR_MESSAGES[key]
      } else {
        vm.FORM_ERRORS[key] = ''
      }
    }
  }, true)

  $scope.$watch(function () {
    return vm.STATES.value
  }, function (newValue, oldValue) {
    validateDropdowns('state', newValue, oldValue)
  }, true)

  $scope.$watch(function () {
    return vm.COUNTRIES.value
  }, function (newValue, oldValue) {
    validateDropdowns('country', newValue, oldValue)
  }, true)

  $scope.$watch(function () {
    return vm.EXPOS.value
  }, function (newValue, oldValue) {
    validateDropdowns('expoId', newValue, oldValue)
  }, true)

  $scope.$watch(function () {
    return vm.FORM.sponsorshipLevel
  }, function (newValue, oldValue) {
    validateDropdowns('sponsorshipLevel', newValue, oldValue)
  })
}

angular.module('app').controller('AttendeeJoinController', ['$scope', '$rootScope', 'vcRecaptchaService', AttendeeJoinController])
